import { media } from "../assets/media";

export const projects = [
  {
    id: 1,
    title: "EWG Redesign",
    description: "UI/UX Design",
    year: 2024,
    mediaFiles: [media.ewgarticles, media.ewgdonate, media.ewgvideo],
  },
  {
    id: 2,
    title: "Mercy",
    description: "Album Cover",
    year: 2024,
    mediaFiles: [null, media.mercyposter, media.mercyalbum],
  },
  {
    id: 3,
    title: "Video",
    description: "Product Launch",
    year: 2024,
    mediaFiles: [null, null, media.motionvideoshort],
  },
  {
    id: 4,
    title: "Street Culture",
    description: "Print Magazine",
    year: 2024,
    mediaFiles: [media.cover, media.streetcultback, media.streetcultvideo],
  },
  {
    id: 5,
    title: "Anete",
    description: "Client Portfolio",
    year: 2024,
    mediaFiles: [media.anetelanding, media.aneteprojects, media.aneteportvideo],
  },
  {
    id: 6,
    title: "BOOMBOX",
    description: "Music Sharing Platform",
    year: 2024,
    mediaFiles: [media.boomboxhome, media.boomboxhsongs, media.boomboxvideo],
  },
  {
    id: 7,
    title: "TrackEase",
    description: "Item Tracking App",
    year: 2024,
    mediaFiles: [
      media.trackeaseitem,
      media.trackeasehome,
      media.trackeasevideo,
    ],
  },
  {
    id: 8,
    title: "Portfolio",
    description: "Old Personal Portfolio",
    year: 2024,
    mediaFiles: [
      media.portfolioview,
      media.portfolioskills,
      media.portfoliovido,
    ],
  },
  {
    id: 9,
    title: "Studly",
    description: "Personalized Tutoring",
    year: 2023,
    mediaFiles: [media.studlylanding, media.studlyfooter, media.studylvideo],
  },
  {
    id: 10,
    title: "Verbum",
    description: "Language Learning App",
    year: 2023,
    mediaFiles: [media.verbumcard, media.verbumhistory, media.verbumproject],
  },
  {
    id: 11,
    title: "Branding",
    description: "Personal Branding",
    year: 2024,
    mediaFiles: [
      media.brandinglogos,
      media.brandingtypograpgy,
      media.brandingvideo,
    ],
  },
];
